import styled from "styled-components";
import { fontFamily } from "../../../../shared/styles/theme";
import { primaryColor, secondaryBlueColor, white } from "../../../../shared/styles/color";
import { FiHeadphones, FiShield, FiUsers } from "react-icons/fi";
import talentImg from "../../../../../assets/images/talent_1.jpg";

const FEATURES = [
  {
    icon: FiShield,
    title: "Trusted Platform",
    text: "Verified users and secure payments you can rely on.",
  },
  {
    icon: FiUsers,
    title: "Endless Opportunities",
    text: "Find the right projects or talent to grow your business.",
  },
  {
    icon: FiHeadphones,
    title: "24/7 Support",
    text: "We're here to help you every step of the way.",
  },
];

const SignupAds = () => {
  return (
    <Wrap>
      <Badge>
        <Sparkle aria-hidden>✨</Sparkle>
        Join Liber today
      </Badge>

      <Headline>
        Create your account and get started with <Accent>Liber</Accent>
      </Headline>

      <Subhead>
        Join thousands of freelancers and businesses building success together.
      </Subhead>

      <FeatureList>
        {FEATURES.map(({ icon: Icon, title, text }) => (
          <FeatureItem key={title}>
            <FeatureIcon aria-hidden>
              <Icon size={18} strokeWidth={2} />
            </FeatureIcon>
            <div>
              <FeatureTitle>{title}</FeatureTitle>
              <FeatureText>{text}</FeatureText>
            </div>
          </FeatureItem>
        ))}
      </FeatureList>

      <IllustrationArea aria-hidden>
        <DotGrid />
        <PhotoRing>
          <Photo src={talentImg} alt="" />
        </PhotoRing>
        <Star $top="18%" $left="8%">✦</Star>
        <Star $top="62%" $left="4%">✦</Star>
        <Star $top="28%" $right="6%">✦</Star>
      </IllustrationArea>
    </Wrap>
  );
};

export default SignupAds;

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  height: 100%;
  padding: 8px 0 24px;
`;

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 999px;
  background: ${secondaryBlueColor};
  color: ${primaryColor};
  font-family: ${fontFamily.font};
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 24px;
`;

const Sparkle = styled.span`
  font-size: 14px;
  line-height: 1;
`;

const Headline = styled.h1`
  font-family: ${fontFamily.font};
  font-size: clamp(1.75rem, 3vw, 2.25rem);
  font-weight: 700;
  color: #111827;
  line-height: 1.25;
  margin: 0 0 14px;
  max-width: 420px;
`;

const Accent = styled.span`
  color: ${primaryColor};
`;

const Subhead = styled.p`
  font-family: ${fontFamily.font};
  font-size: 15px;
  line-height: 1.6;
  color: #6b7280;
  margin: 0 0 28px;
  max-width: 400px;
`;

const FeatureList = styled.ul`
  list-style: none;
  margin: 0 0 32px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 420px;
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 14px;
`;

const FeatureIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${secondaryBlueColor};
  color: ${primaryColor};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const FeatureTitle = styled.div`
  font-family: ${fontFamily.font};
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 4px;
`;

const FeatureText = styled.div`
  font-family: ${fontFamily.font};
  font-size: 13px;
  line-height: 1.5;
  color: #6b7280;
`;

const IllustrationArea = styled.div`
  position: relative;
  width: 100%;
  max-width: 340px;
  margin-top: auto;
  min-height: 200px;
`;

const DotGrid = styled.div`
  position: absolute;
  left: 0;
  bottom: 24px;
  width: 72px;
  height: 72px;
  background-image: radial-gradient(#cbd5e1 1.5px, transparent 1.5px);
  background-size: 12px 12px;
  opacity: 0.7;
`;

const PhotoRing = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: 12px;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  overflow: hidden;
  border: 6px solid ${secondaryBlueColor};
  background: ${white};
  box-shadow: 0 8px 32px rgba(17, 138, 178, 0.12);
`;

const Photo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const Star = styled.span`
  position: absolute;
  ${(p) => p.$top && `top: ${p.$top};`}
  ${(p) => p.$left && `left: ${p.$left};`}
  ${(p) => p.$right && `right: ${p.$right};`}
  color: ${primaryColor};
  font-size: 22px;
  opacity: 0.55;
  line-height: 1;
`;
